export type { AllPersonnelProps } from './all-personnel';
export * from './all-personnel.routes';

export { default as AllPersonnel, default } from './all-personnel';
